
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/forgot_password",
      function () {
        return require("private-next-pages/account/forgot_password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/forgot_password"])
      });
    }
  